import React from 'react'

const UserIcon = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.7599 2.97C12.1199 3.5025 12.3299 4.14 12.3299 4.83C12.3224 6.63 10.9049 8.0925 9.11991 8.1525C9.04491 8.145 8.95491 8.145 8.87241 8.1525C7.21491 8.1 5.87241 6.8325 5.69241 5.2125C5.47491 3.285 7.05741 1.5 8.99241 1.5" stroke="#1E293B" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M5.2426 10.92C3.4276 12.135 3.4276 14.115 5.2426 15.3225C7.3051 16.7025 10.6876 16.7025 12.7501 15.3225C14.5651 14.1075 14.5651 12.1275 12.7501 10.92C10.7026 9.5475 7.3201 9.5475 5.2426 10.92Z" stroke="#1E293B" strokeWidth="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    )
}

export default UserIcon






